// validators/date-range-validator.js
import { ValidatorInterface } from "../validator-interface";

export class DateRangeValidator extends ValidatorInterface {
    getZodSchema(baseSchema, options = {}) {
        const { min, max, message } = options;
        const errorMessage = message || this._getDefaultErrorMessage(min, max);

        // Refine the base schema (expecting string or date)
        return baseSchema.refine(
            value => {
                // Skip empty values (handled by required validator if needed)
                if (!value) return true;

                let date;
                try {
                    // Attempt to parse the value into a Date object
                    date = new Date(value);
                    // Check for invalid date (e.g., from unparseable string)
                    if (isNaN(date.getTime())) return false;
                } catch (e) {
                    // Error during date construction
                    return false;
                }

                let isValid = true;

                // Min date check (inclusive)
                if (min) {
                    try {
                        const minDate = new Date(min);
                        if (!isNaN(minDate.getTime()) && date < minDate) {
                            isValid = false;
                        }
                    } catch (e) {
                        /* Ignore invalid min date format */
                    }
                }

                // Max date check (inclusive)
                if (max && isValid) {
                    try {
                        const maxDate = new Date(max);
                        if (!isNaN(maxDate.getTime()) && date > maxDate) {
                            isValid = false;
                        }
                    } catch (e) {
                        /* Ignore invalid max date format */
                    }
                }

                return isValid;
            },
            {
                message: errorMessage
            }
        );
    }

    getErrorMessage(field, options = {}) {
        const { min, max, message } = options;
        return message || this._getDefaultErrorMessage(min, max);
    }

    _getDefaultErrorMessage(min, max) {
        const formatDate = dateString => {
            try {
                const date = new Date(dateString);
                return isNaN(date.getTime()) ? null : date.toLocaleDateString();
            } catch (e) {
                return null;
            }
        };

        const minDateStr = min ? formatDate(min) : null;
        const maxDateStr = max ? formatDate(max) : null;

        if (minDateStr && maxDateStr) {
            return `Please enter a date between ${minDateStr} and ${maxDateStr}`;
        } else if (minDateStr) {
            return `Please enter a date on or after ${minDateStr}`;
        } else if (maxDateStr) {
            return `Please enter a date on or before ${maxDateStr}`;
        } else {
            return "Please enter a valid date within the allowed range";
        }
    }
}
